import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import { store } from "./store/store";
import App from "./App/index";
import config from "./config/config";
import { createRoot } from "react-dom/client";

const root = createRoot(document.getElementById("root")); // Use createRoot from react-dom/client

root.render(
  <Provider store={store}>
    <BrowserRouter basename={config.basename}>
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
